module.exports = __webpack_public_path__ + "img/couples-059.2105ae83.jpg";